import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SousTraitant } from '../models/models';

@Injectable({
  providedIn: 'root'
})
export class SousTraitantService {
  private readonly apiUrl = `${environment.apiUrl}/sous-traitants`;

  constructor(private http: HttpClient) {}

  getSousTraitants(search = '', page = 0, size = 10, sort = 'denomination,asc', showArchived = false): Observable<{content: SousTraitant[], totalElements: number, totalPages: number}> {
    const params = new HttpParams()
      .set('search', search)
      .set('page', String(page))
      .set('size', String(size))
      .set('sort', sort)
      .set('showArchived', String(showArchived));
    return this.http.get<{content: SousTraitant[], totalElements: number, totalPages: number}>(this.apiUrl, { params });
  }

  getAllSousTraitants(): Observable<SousTraitant[]> {
    return this.http.get<SousTraitant[]>(this.apiUrl);
  }

  createSousTraitant(sousTraitant: SousTraitant): Observable<any> {
    return this.http.post(this.apiUrl, sousTraitant);
  }

  getSousTraitantById(id: number): Observable<SousTraitant> {
    return this.http.get<SousTraitant>(`${this.apiUrl}/${id}`);
  }

  updateSousTraitant(id: number, sousTraitant: SousTraitant): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, sousTraitant);
  }

  deleteSousTraitant(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }

  canDeleteSousTraitant(id: number): Observable<boolean> {
    return this.http.get<boolean>(`${this.apiUrl}/${id}/can-delete`);
  }
}
